export default __webpack_public_path__ + "static/media/thumbnail.99ba572c.png";